<template>
  <router-view />
</template>

<script>
export default {
  name: 'EmployeesPayrollIndex'
}
</script>
